import React from 'react';

import { IconChevronDown } from '@tabler/icons';

import {
  Select,
  InputLabel,
  SelectContainer,
  SelectIconWrapper,
} from '../../../components/Generic';

interface ICustomSelectInput {
  label: string;
  value: any;
  filters: any;
  onChange: any;
}

const CustomSelectInput: React.FC<ICustomSelectInput> = ({
  label,
  value,
  filters,
  onChange,
}) => {
  return (
    <div>
      <InputLabel>{label}</InputLabel>

      <SelectContainer>
        {typeof filters?.[0] === 'object' && filters?.[0] ? (
          <Select onChange={onChange} value={value}>
            {filters?.map(
              (option: any) =>
                option && (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ),
            )}
          </Select>
        ) : (
          <Select onChange={onChange} value={value}>
            <option value="">Qualquer</option>

            {filters?.map(
              (option: any) =>
                option && (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ),
            )}
            <option value="vazio">Vazio</option>
          </Select>
        )}

        <SelectIconWrapper style={{ right: 20 }}>
          <IconChevronDown size={20} color="var(--gray-9)" />
        </SelectIconWrapper>
      </SelectContainer>
    </div>
  );
};

export default CustomSelectInput;
